
export default [
  {
    path: '/bankcard/add',
    name: 'bankcardAdd',
    component: () => import('../view/bankcard/add'),
    meta: { pageName: 'page_add_bank_card', title: '绑定银行卡' }
  },
  {
    path: '/bankcard/list',
    component: () => import('../view/bankcard/list.vue'),
    name: 'bankcardList',
    meta: { pageName: 'page_bankcard_select', title: '选择银行卡' }
  },
  {
    path: '/bankcard/support',
    name: 'bankcardSupport',
    component: () => import('../view/bankcard/support'),
    meta: { pageName: 'page_bankcard_support', title: '支持的银行卡' }
  },
  {
    path: '/bankcard/repay-bank-list',
    name: 'repayBankList',
    component: () => import('../view/bankcard/repay-bank-list'),
    meta: { pageName: 'page_bankcard_support', title: '扣款账户' }
  },  
  {
    path: '/bankcard/repay-bank-detail',
    name: 'repayBankDetail;',
    component: () => import('../view/bankcard/repay-bank-detail'),
    meta: { pageName: 'page_bankcard_support', title: '扣款账户' }
  }
]